export default __webpack_public_path__ + "static/media/dtx.5526ffa2.svg";